@if ((workflowitem$ | async) && (item$ | async)) {
  <ds-item-list-preview [item]="item$.value"
    [object]="object"
                               [showLabel]="showLabel"
                               [showMetrics]="showMetrics"
    [showSubmitter]="showSubmitter"
                               [showThumbnails]="showThumbnails"
                               [showWorkflowStatistics]="true"
    [badgeContext]="badgeContext"
                               [workflowItem]="workflowitem$.value"
                               [showCorrection]="showCorrection"></ds-item-list-preview>
  <!-- Display duplicate alert, if feature enabled and duplicates detected -->
  <ng-container *ngVar="(duplicates$|async)?.length as duplicateCount">
    @if (duplicateCount > 0) {
      <div [ngClass]="'row'">
        <div [ngClass]="'col-2'"></div>
        <div [ngClass]="'col-10'">
          <div class="d-flex alert alert-warning w-100">
            {{ duplicateCount }} {{ 'submission.workflow.tasks.duplicates' | translate }}
          </div>
        </div>
      </div>
    }
  </ng-container>
  <div class="row">
    <div [ngClass]="showThumbnails ? 'offset-3 offset-md-2 col-9 col-md-10 ps-3' : 'ms-3'">
      <ds-claimed-task-actions [item]="item$.value"
        [object]="dso"
        [workflowitem]="workflowitem$.value"
      (processCompleted)="reloadedObject.emit($event.reloadedObject)"></ds-claimed-task-actions>
    </div>
  </div>
}
